<template>
  <div id="not-found">
    <div class="content">
      <h1>Page not found</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>